//This hacks in CSS binding
kendo.data.binders.cssClass = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        var target = $(element);
        this.trueClass = target.data("trueclass");
        this.falseClass = target.data("falseclass");
    },
    refresh: function () {
        var enabled = this.bindings["cssClass"].get();

        if (enabled) {
            if (this.falseClass != null)
                $(this.element).removeClass(this.falseClass);
            $(this.element).addClass(this.trueClass);
        }
        else {
            if (this.falseClass == null) {
                $(this.element).removeClass(this.trueClass);
            }
            else {
                $(this.element).removeClass(this.trueClass);
                $(this.element).addClass(this.falseClass);
            }
        }
    }
});

//Date Binding
// SYNTAX: data-bind="date: dateProperty" data-dateformat="MMM yyyy"
kendo.data.binders.date = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        this.dateformat = $(element).data("dateformat");
    },
    refresh: function () {
        var data = this.bindings["date"].get();
        if (data) {
            var dateObj = new Date(data);
            $(this.element).text(kendo.toString(dateObj, this.dateformat));
        }
    }
});

//Date Binding
// SYNTAX: data-bind="wcfdate: dateProperty" data-dateformat="MMM yyyy"
kendo.data.binders.wcfdate = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        this.dateformat = $(element).data("dateformat");
    },
    refresh: function () {
        var data = this.bindings["wcfdate"].get();
        if (data) {
            var dateObj = new Date(kendo.parseDate(data));
            $(this.element).text(kendo.toString(dateObj, this.dateformat));
        }
    }
});

//Toggle\Active Binding
//Puts the class 'active' on an element if the data matches the bound value
// SYNTAX: data-bind="active: viewModelProperty" data-activeon="archive"
// In the above case if the value of viewModelProperty equals 'archive' then 'active' is applied to the element
kendo.data.binders.active = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        this.activeon = $(element).data("activeon");
    },
    refresh: function () {
        var text = this.bindings["active"].get();

        if (text === this.activeon) {
            $(this.element).addClass("active");
        }
        else {
            $(this.element).removeClass("active");
        }
    }
});

//MEDPORTAL CORE LAYOUT CUSTOM


kendo.data.binders.hidden = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);
    },
    refresh: function () {
        var shouldHide = this.bindings["hidden"].get();

        if (shouldHide)
            $(this.element).css("visibility", "hidden");
        else
            $(this.element).css("visibility", "visible");
    }
});
//END MEDPORTAL CORE LAYOUT